module.exports = __webpack_public_path__ + "static/media/iconBillsActive.855c4625.svg";